export const validateTaskType = (value: unknown) =>
  typeof value === "string" &&
  value.trim() &&
  value.trim().toLowerCase() !== "none"
    ? undefined
    : "Выберите тип задачи";
export function requireTaskType<T extends { type?: unknown }>(
  data: T,
  previous?: { type?: unknown },
): T {
  if ((!previous || data.type !== previous.type) && validateTaskType(data.type))
    throw new Error("Выберите тип задачи");
  return data;
}
